// extracted by mini-css-extract-plugin
export default {"cls1":"OD_iVS69Nsf4yd_dVU1w","cls2":"Q46Hm3TzFDnzOJ8C28r2 OD_iVS69Nsf4yd_dVU1w"};